import { TicketStatus } from '@delmonicos/shared-sdk/libs/cpms/src/libs/core/src/enums/ticket-status.enum';

import { TicketSection } from './ticket-section.component';

interface TicketTabResolvedProps {
  onActionRead: (id: string) => void;
}

export const TicketTabResolved = ({
  onActionRead,
}: TicketTabResolvedProps): React.JSX.Element => {
  return (
    <TicketSection status={TicketStatus.Closed} onActionRead={onActionRead} />
  );
};
